export function LocationIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_80_109)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.64447 5.20768C8.23471 4.81515 7.67859 4.59526 7.0986 4.59526C6.05414 4.59526 5.15449 5.30139 4.95029 6.28198C4.74616 7.26332 5.29382 8.24605 6.25893 8.62912C7.22328 9.01205 8.33626 8.68888 8.91696 7.85733C9.49695 7.02579 9.38296 5.91688 8.6443 5.20911L8.64447 5.20768ZM7.0986 3.58884C7.95512 3.58884 8.77619 3.91424 9.38158 4.49419C9.98776 5.07413 10.3282 5.86068 10.3282 6.68114C10.329 7.50088 9.9893 8.28817 9.38466 8.86885C8.77925 9.4488 7.95893 9.77567 7.10246 9.77715C6.24594 9.77788 5.42487 9.45324 4.8179 8.87403C4.21172 8.29482 3.87049 7.509 3.86895 6.68858C3.86741 5.86735 4.20708 5.07861 4.81252 4.4971C5.4187 3.91568 6.24126 3.58884 7.0986 3.58884ZM5.77917 14.2065C4.39888 12.6459 2.89221 10.9385 1.99108 9.59343H1.99185C1.27552 8.43722 1.01055 7.07441 1.24394 5.7486C1.47655 4.42269 2.19288 3.21843 3.26506 2.35086C4.33648 1.48241 5.69515 1.00577 7.0985 1.00577C8.50185 1.00577 9.86064 1.48241 10.9319 2.35086C12.0041 3.21858 12.7204 4.42279 12.9531 5.7486C13.1864 7.0745 12.9215 8.43724 12.2051 9.59343C11.0005 11.3901 8.72526 13.8213 7.0985 15.7117C6.68873 15.2358 6.24044 14.7297 5.77907 14.2006L5.77917 14.2065ZM6.68652 16.8111C4.97119 14.7673 2.47252 12.1604 1.11373 10.1357C0.261075 8.77662 -0.0593469 7.17112 0.208704 5.60618C0.476754 4.04119 1.31709 2.61871 2.57944 1.59153C3.84109 0.565185 5.44313 0.00146484 7.09848 0.00146484C8.75383 0.00146484 10.3559 0.565185 11.6175 1.59153C12.8799 2.61861 13.7203 4.04123 13.9883 5.60618C14.2563 7.17116 13.9359 8.77668 13.0832 10.1357C11.7206 12.1625 9.22198 14.7673 7.50432 16.8111C7.40573 16.9306 7.25477 17 7.09532 17C6.93588 17 6.78588 16.9306 6.68652 16.8111Z"
          fill="#3D3D3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_80_109">
          <rect width="14" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
